export { Printer as default } from './Printer';
